import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {of} from 'rxjs/observable/of';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class WalletService {

  private resourceUrl = environment.apiUrl + 'wallet';

  constructor(private http: HttpClient) { }

  getList(): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/list');
  }

  getListCount(): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/list/count');
  }
  getListCountStructure(idStructure): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + idStructure + '/count');
  }
  delete(idCredit: number): Observable<any> {
    return this.http.delete<any>(this.resourceUrl + '/credit/' + idCredit);
  }
  getStructure(idStructure): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + idStructure + '');
  }
  getStructureCredit(idStructure): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + idStructure + '/credits');
  }
  getStructureDebit(idStructure): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/' + idStructure + '/debit');
  }
  getListCountMe(): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/me/count');
  }

  getStructureMe(): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/me');
  }
  getStructureCreditMe(): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/me/credits');
  }
  getStructureDebitMe(): Observable<any> {
    return this.http.get<any>(this.resourceUrl + '/me/debit');
  }


  addDebit(request: any, idStructure): Observable<any> {
    return this.http.post<any>(this.resourceUrl + '/me/debit/add/' + idStructure, request);
  }
  deleteDebit(idDebit: number): Observable<any> {
    return this.http.delete<any>(this.resourceUrl + '/debit/' + idDebit);
  }

  add(request: any): Observable<any> {
    return this.http.post<any>(this.resourceUrl + '/me/add', request);
  }
  addCopntributo(request: any, idStructure): Observable<any> {
    return this.http.post<any>(this.resourceUrl + '/' + idStructure + '/contribition', request);
  }
  addPaypal(request: any): Observable<any> {
    return this.http.post<any>(this.resourceUrl + '/me/add/paypal', request);
  }
  pay(idStructure, request: any): Observable<any> {
    return this.http.post<any>(this.resourceUrl + '/' + idStructure + '/pay', request);
  }
  approve(idStructure, request: any): Observable<any> {
    return this.http.post<any>(this.resourceUrl + '/' + idStructure + '/approve', request);
  }

  private changeStructureSubject = new Subject<string>();
  changeStructure$ = this.changeStructureSubject.asObservable();

  changeStructure(idStructure: string) {
    this.changeStructureSubject.next(idStructure);
  }

  globalIdStructure: string;
  setGlobalStructure(idStructure: string) {
    this.globalIdStructure = idStructure;
  }
  getGlobalStructure():string{
    return this.globalIdStructure;
  }

}



// WEBPACK FOOTER //
// ./src/app/wallet/wallet.service.ts